import { render, staticRenderFns } from "./ExpressionsPreview.vue?vue&type=template&id=20ded3c4&lang=pug&"
import script from "./ExpressionsPreview.vue?vue&type=script&lang=js&"
export * from "./ExpressionsPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports